var map = {
	"./PorkArgentina.png": "45d6",
	"./PorkAustria.png": "9c0a",
	"./PorkBrazil.png": "dea9",
	"./PorkCanada.png": "611f",
	"./PorkChile.png": "369a",
	"./PorkCostaRica.png": "9126",
	"./PorkDenmark.png": "c827",
	"./PorkFinland.png": "a304",
	"./PorkFrance.png": "a9f7",
	"./PorkGermany.png": "57ab",
	"./PorkIreland.png": "28e1",
	"./PorkItaly.png": "7aa9",
	"./PorkMexico.png": "de0c",
	"./PorkNetherlands.png": "a03f",
	"./PorkPortugal.png": "5f52",
	"./PorkSpain.png": "e6bf",
	"./PorkSwitzerland.png": "f4ca",
	"./PorkTheUnitedKingdom.png": "2573",
	"./PorkTheUnitedStates.png": "5d78"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95e9";